// extracted by mini-css-extract-plugin
module.exports = {"footer":"FormFooter_footer__3UaJ2","flex":"FormFooter_flex__1wC89"};